module.exports = [{
      plugin: require('/Users/kanej/projects/sites/www.kanej.me/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
